const configFirebase = {
    apiKey: "AIzaSyBvFGjJil2BB20_uzA2q_2Ag9J_AJ6lDwg",
    authDomain: "teste-eneagrama.firebaseapp.com",
    databaseURL: "https://teste-eneagrama.firebaseio.com",
    projectId: "teste-eneagrama",
    storageBucket: "teste-eneagrama.appspot.com",
    messagingSenderId: "609512024385",
    appId: "1:609512024385:web:92635f438241d42d58d9c0",
    measurementId: "G-4GNHDTCXE7"
};

const configFacebook =  {
    "appId": "142169699786355"
  }

module.exports = {
    configFirebase: configFirebase,
    configFacebook: configFacebook
}